module.exports = __webpack_public_path__ + "static/media/icon-scheduling-week.ce3e0426.svg";